import { createContext, useContext, useEffect, useState } from "react";
import { T } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("vp-lang") || "en");

  useEffect(() => {
    localStorage.setItem("vp-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, vars) => {
    const resolve = (dict) => key.split(".").reduce((o, k) => (o == null ? o : o[k]), dict);
    let v = resolve(T[lang]) ?? resolve(T.en) ?? key;
    if (typeof v === "string" && vars) {
      Object.entries(vars).forEach(([k, val]) => {
        v = v.replaceAll(`{${k}}`, String(val));
      });
    }
    return v;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);

export function usePick() {
  const { lang } = useLang();
  return (item, field) => {
    if (lang === "es" && item[`${field}_es`]) return item[`${field}_es`];
    return item[field];
  };
}

export function LangToggle({ className = "", suffix = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex rounded-full border border-ink/10 bg-white p-0.5 ${className}`} data-testid={`lang-toggle${suffix}`}>
      {["en", "es"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}${suffix}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider transition-colors ${
            lang === l ? "bg-terracotta text-sand" : "text-ink/50 hover:text-ink"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
